import { useNavigate, useSearch } from "@tanstack/react-router";
import { MemoDialog } from "./MemoDialog";

/**
 * URL の `?memo=<ID>` で、どの画面でもメモのダイアログを開く(SPEC §13.6。本文の「@」で入れたメモへのリンク)。
 * 閉じたら、URL から外す(戻るで開き直さないよう、履歴は置き換える)。
 */
export function MemoFromUrl() {
  const search = useSearch({ strict: false }) as Record<string, unknown>;
  const navigate = useNavigate();
  const memoId = typeof search["memo"] === "string" ? search["memo"] : null;
  return (
    <MemoDialog
      memoId={memoId}
      draftId={null}
      open={memoId !== null}
      onOpenChange={(open) => {
        if (open) return;
        void navigate({
          to: ".",
          search: (prev: Record<string, unknown>) => {
            const { memo: _memo, ...rest } = prev;
            return rest;
          },
          replace: true,
        });
      }}
    />
  );
}
